<template>
  <div>

    <router-link
      :to="{ name: 'master-category-list' }"
      class="text-decoration-none text-white"
    >
      <b-button
        class="mb-1"
        variant="primary"
      >
        <feather-icon
          icon="ArrowLeftIcon"
          class="mr-75"
        />
        Kembali
      </b-button>
    </router-link>
    <b-card>
      <validation-observer ref="simpleRules">
        <b-form>
          <b-row>
            <!-- Nama ekspedisi -->
            <b-col cols="12">
              <b-form-group
                label="Nama Kategori"
                label-for="name"
                label-cols-md="4"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Nama Kategori"
                  rules="required">
                  <b-form-input
                    id="name"
                    v-model="name"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Masukkan Nama Kategori"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider></b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-group
                label="Keterangan"
                label-for="desc"
                label-cols-md="4"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Keterangan"
                  rules="required">
                  <b-form-input
                    id="desc"
                    v-model="desc"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Masukkan Keterangan"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider></b-form-group>
            </b-col>
            <!-- Tombol Aksi -->
            <b-col
              md="8"
              offset-md="4"
            >
              <b-button
                type="submit"
                variant="success"
                class="mr-1"
                @click.prevent="validationForm"
              >
                Simpan
              </b-button>
              <b-button
                type="reset"
                variant="outline-secondary"
              >
                Reset
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer></b-card>
  </div>
</template>

<script>
import {
  BFormInput, BFormGroup, BRow, BCol, BButton, BCard, BForm,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { heightTransition } from '@core/mixins/ui/transition'
// eslint-disable-next-line import/no-cycle
import Ripple from 'vue-ripple-directive'
import { required } from '@validations'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BFormInput,
    BFormGroup,
    BRow,
    BForm,
    BCol,
    BButton,
    BCard,

  },
  directives: {
    Ripple,
  },
  mixins: [heightTransition],
  data() {
    return {
      id: '',
      name: '',
      desc: '',
      required,
    }
  },
  computed: {},
  created() {
    this.$http.get(`/category/${this.$route.params.id}`)
      .then(res => {
        const { category } = res.data
        this.name = category.name
        this.desc = category.desc
        this.id = category.id
      })

    window.addEventListener('resize', this.initTrHeight)
  },
  mounted() {
    this.initTrHeight()
  },
  methods: {
    submitCategory() {
      const payload = {
        id: this.id,
        name: this.name,
        desc: this.desc,
      }

      this.$http.put('/category/update', payload)
        .then(() => {
          this.$bvToast.toast('Kategori berhasil diedit!', {
            title: 'Sukses',
            variant: 'success',
            solid: true,
          })
          // Reset redirect
          this.$router.push({ name: 'master-category-list' })
        })
        .catch(err => {
          console.error(err)
          this.$bvToast.toast('Gagal mengedit kategori.', {
            title: 'Error',
            variant: 'danger',
            solid: true,
          })
        })
    },
    initTrHeight() {
      this.trSetHeight(null)
      this.$nextTick(() => {
        this.trSetHeight(this.$refs.form.scrollHeight)
      })
    },
    validationForm() {
      const error = false
      if (!error) {
        this.$refs.simpleRules.validate().then(success => {
          if (success) {
            this.submitCategory()
          } else {
            this.$bvToast.toast('Lengkapi Data Sebelum Submit!', {
              title: 'Error',
              variant: 'danger',
              solid: true,
            })
          }
        })
      }
    },
  },
}
</script>
